"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  * {\n    font-family: ", " !important;\n  }\n\n  .input {\n    display: flex;\n    flex: 0 0 auto;\n    width: 272px;\n    position: relative;\n    height: 40px;\n    background: ", ";\n    padding: 0 8px 0 12px;\n    border-radius: 2px;\n    border: 1.5px solid transparent;\n    cursor: pointer;\n    color: ", ";\n    font-family: ", ";\n    font-size: 16px;\n    box-sizing: border-box;\n\n    ::placeholder {\n      color: ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      cursor: not-allowed;\n    }\n  }\n\n  table thead th {\n    color: ", " !important;\n    font-family: ", ";\n  }\n\n  table tbody {\n    font-family: ", ";\n\n    td._1PHXZRv9_4KmFMrk8q46oq {\n      background-color: ", " !important;\n      color: ", " !important;\n    }\n    td._2CQ5vWlIzMzWrunFH0Ghn9 {\n      color: ", " !important;\n    }\n  }\n"], ["\n  * {\n    font-family: ", " !important;\n  }\n\n  .input {\n    display: flex;\n    flex: 0 0 auto;\n    width: 272px;\n    position: relative;\n    height: 40px;\n    background: ", ";\n    padding: 0 8px 0 12px;\n    border-radius: 2px;\n    border: 1.5px solid transparent;\n    cursor: pointer;\n    color: ", ";\n    font-family: ", ";\n    font-size: 16px;\n    box-sizing: border-box;\n\n    ::placeholder {\n      color: ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      background: ", ";\n      cursor: not-allowed;\n    }\n  }\n\n  table thead th {\n    color: ", " !important;\n    font-family: ", ";\n  }\n\n  table tbody {\n    font-family: ", ";\n\n    td._1PHXZRv9_4KmFMrk8q46oq {\n      background-color: ", " !important;\n      color: ", " !important;\n    }\n    td._2CQ5vWlIzMzWrunFH0Ghn9 {\n      color: ", " !important;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map